import { zep } from '@zillow/universal-analytics';
import { ZHLExperienceAnalyticEventClickstreamTriggerType } from 'src/services/graphql/generated/graphql';
import * as ApplicationConfigurationService from 'src/services/config/ApplicationConfigurationService.client';
import { isSyntheticTest } from 'src/utils/validators/isSyntheticTest';
import { ClickstreamEvent } from '../types';
import { SEMANTIC_EVENTS } from '../blocks/semantic';
import { ZEP_EVENTS, REGISTERED_CLICKSTREAM_EVENTS } from './registeredEvents';

const SEMANTIC_TO_REGISTERED_EVENT_MAP = Object.entries(SEMANTIC_EVENTS).reduce(
    (acc, [registeredEventKey, semanticEventName]) => {
        acc[semanticEventName] = registeredEventKey as keyof typeof REGISTERED_CLICKSTREAM_EVENTS;
        return acc;
    },
    {} as Record<string, keyof typeof REGISTERED_CLICKSTREAM_EVENTS>
);

export const trackZepEvent = (clickstreamEvent: ClickstreamEvent): void => {
    if (isSyntheticTest()) {
        return;
    }

    const semanticEventName = clickstreamEvent?.semantic?.semantic_event_nm;
    const triggerTypeValue = clickstreamEvent?.clickstream_trigger?.trigger_type_nm;

    if (!semanticEventName || !triggerTypeValue) {
        return;
    }
    const registeredEventKey = SEMANTIC_TO_REGISTERED_EVENT_MAP[semanticEventName];
    const zepEvent = registeredEventKey ? ZEP_EVENTS[registeredEventKey as keyof typeof ZEP_EVENTS] : undefined;

    if (!zepEvent) {
        return;
    }

    const triggerTypeName =
        triggerTypeValue === ZHLExperienceAnalyticEventClickstreamTriggerType.INTERACTION
            ? ZHLExperienceAnalyticEventClickstreamTriggerType.INTERACTION
            : ZHLExperienceAnalyticEventClickstreamTriggerType.IMPRESSION;
    zep.event(zepEvent, 1)
        .withPayload({
            lead_id: clickstreamEvent.zhl_discovery?.lead_id,
            journey_stage_cd: clickstreamEvent.zhl_discovery?.journey_stage_cd,
            variant_nm: clickstreamEvent.zhl_discovery?.variant_nm,
        })
        .withCategory(
            triggerTypeName === ZHLExperienceAnalyticEventClickstreamTriggerType.INTERACTION
                ? zep.categories.INTERACTION
                : zep.categories.IMPRESSION
        )
        .withPageInfo('mortgage-dashboard', 'Mortgage Dashboard')
        .withOptions({
            env: ApplicationConfigurationService.ConfigProvider.getInstance().runtimeConfig.isLowerEnvironment
                ? 'dev'
                : 'prod',
        })
        .sendAsync();
};
